
import React from 'react';
import {columns} from "./columns";
import { getData } from '../../requests/CRUD';
import { TEAM } from '../../consts/tables';
import { executeQuery } from '../../requests/executeQuery';
import {Link} from "react-router";
import { HSC_AGENTS_COUNT, HSC_BUYERS_COUNT, HSC_FOLLOW_UP_COUNT,HSC_COURTING_COUNT,HSC_PROPERTIES_COUNT,HSC_SELLERS_COUNT } from '../../consts/queries';
// The page is built on the Summit Pipeline's classes; nothing else loads them.
import '../Pipeline/Pipeline.scss';

export default class HscFollowUp extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            rows: {},
            query:{},
            loading: false,
            isPrint: false,
            printBackground: '',
            hscAgentsData:[]
        };

        this.beforePrint = this.beforePrint.bind(this);
        this.afterPrint = this.afterPrint.bind(this);
    }


    beforePrint() {
        this.setState({isPrint: true});
    }

    afterPrint() {
        this.setState({isPrint: false});
    }

    componentDidMount(){
    

        getData({
            tableCode: TEAM,
            options: {
                limit: {
                    "count": 1000,
                    "offset": 0
                },
                column: [
                    "ARCIMEDES_ROW_ID",
                    "FIRST_NAME",
                    "LAST_NAME",
                    "IS_AGENT",
                    "EMAIL",
                    "DELETED"
                ],
            }
        }).then((res) => {
            if (res && res.success && Array.isArray(res.data) && res.data.length) {
                const hscAgentsData = res.data.reduce((acc, currentValue) => {
                    if (currentValue.EMAIL && currentValue.EMAIL.toLowerCase().includes('highstcapital')&&currentValue.DELETED !== 'y') {
                        const formattedData = {
                            AGENT_ID: currentValue.ARCIMEDES_ROW_ID,
                            AGENT_NAME: `${currentValue.FIRST_NAME} ${currentValue.LAST_NAME}`,
                            EMAIL: currentValue.EMAIL,
                            hsc_properties_count: 0,
                            hsc_agents: 0,
                            hsc_buyers: 0
                        }
                        acc.push(formattedData)
                    }
                    return acc;
                }, [])
                this.setState({ hscAgentsData })
                hscAgentsData && Array.isArray(hscAgentsData) && hscAgentsData.length &&
                hscAgentsData.forEach((item) => {
                    const { EMAIL, AGENT_ID } = item;
                    const { hscAgentsData } = this.state;
                    const hscPropertiesPromise = executeQuery({ queryName: HSC_PROPERTIES_COUNT, params: { HSC_MEMBER_MAIL_ID: EMAIL } });
                    const hscFollowUpPromise = executeQuery({ queryName: HSC_FOLLOW_UP_COUNT, params: { HSC_MEMBER_MAIL_ID: EMAIL } });
                    const hscAgentsCountPromise = executeQuery({ queryName: HSC_AGENTS_COUNT, params: { HSC_MEMBER_MAIL_ID: EMAIL } });
                    const hscBuyersCountPromise = executeQuery({ queryName: HSC_BUYERS_COUNT, params: { HSC_MEMBER_MAIL_ID: EMAIL } });
                    const hscCourtingPromise = executeQuery({ queryName: HSC_COURTING_COUNT, params: { HSC_MEMBER_MAIL_ID: EMAIL } });
                     const hscSellersPromise = executeQuery({ queryName: HSC_SELLERS_COUNT, params: { HSC_MEMBER_MAIL_ID: EMAIL } });
                    
                    Promise.all([hscPropertiesPromise,hscFollowUpPromise, hscAgentsCountPromise,hscBuyersCountPromise,hscCourtingPromise, hscSellersPromise])
                        .then(([hscPropertiesRes,hscFollowUpRes, hscAgentsCountRes, hscBuyersCountRes,hscCourtingCourtingRes,hscSellerCountRes]) => {
                            // Update the data with the results from both queries by using shallow copies of local state data
                            const hscAgentsDataCopy = [...hscAgentsData];
                            // finding the hsc agent index postion using email 
                            const index = hscAgentsData.findIndex((data) => data.EMAIL === EMAIL);
                            if (index !== -1) {
                                hscAgentsDataCopy[index].hsc_properties_count = parseInt(hscPropertiesRes.data[0].hsc_properties_count > 0 ? hscPropertiesRes.data[0].hsc_properties_count : 0, 10);
                                hscAgentsDataCopy[index].hsc_follow_up_count = parseInt(hscFollowUpRes.data[0].hsc_follow_up_count > 0 ? hscFollowUpRes.data[0].hsc_follow_up_count: 0, 10);
                                hscAgentsDataCopy[index].hsc_agents = parseInt(hscAgentsCountRes.data[0].hsc_agents_count > 0 ? hscAgentsCountRes.data[0].hsc_agents_count : 0, 10);
                               // hscAgentsDataCopy[index].hsc_buyers = parseInt(hscBuyersCountRes.data[0].hsc_buyer_count > 0 ? hscBuyersCountRes.data[0].hsc_buyer_count : 0, 10);
                                hscAgentsDataCopy[index].hsc_courting_count = parseInt(hscCourtingCourtingRes.data[0].hsc_courting_count > 0 ? hscCourtingCourtingRes.data[0].hsc_courting_count : 0, 10);
                                
                               // hscAgentsDataCopy[index].hsc_buyers = parseInt(hscSellerCountRes.data[0].hsc_seller_count > 0 ? hscSellerCountRes.data[0].hsc_seller_count : 0, 10);
                                const buyerCount = parseInt(hscBuyersCountRes.data[0].hsc_buyer_count || 0, 10);
                                const sellerCount = parseInt(hscSellerCountRes.data[0].hsc_seller_count || 0, 10);

                                hscAgentsDataCopy[index].hsc_buyers = buyerCount + sellerCount;

                                this.setState({ hscAgentsData: hscAgentsDataCopy });
                            }
                        })
                })
            }
        })

    }

    renderTable(columns, rows) {
    // Flatten subColumns to render rows
        const flatColumns = columns.flatMap(col => col.subColumns || [col]);

        return (
            <table>
            <thead>
                <tr>
                {columns.map((col, index) => {
                    if (col.subColumns) {
                    return (
                        <th key={index} colSpan={col.subColumns.length} className="Pipeline_th">
                        {col.name}
                        </th>
                    );
                    } else {
                    return (
                        <th key={index} rowSpan="2" className="Pipeline_th">
                        {col.name}
                        </th>
                    );
                    }
                })}
                </tr>
                <tr>
                {columns.map((col, index) =>
                    col.subColumns
                    ? col.subColumns.map((subCol, subIndex) => (
                        <th key={`${index}-${subIndex}`} className={`Pipeline_th ${subCol.class || ''}`}>
                            {subCol.name}
                        </th>
                        ))
                    : null
                )}
                </tr>
            </thead>
            <tbody>
                {rows.map((row, rowIndex) => (
                    <tr key={row.AGENT_ID || rowIndex}>
                    {flatColumns.map((col, colIndex) => {
                        const cellValue = row[col.key];

                        // Custom render for AGENT_NAME
                        if (col.key === 'AGENT_NAME') {
                        return (
                            <td key={colIndex} className={col.class || ''}>
                            <Link
                                to={{
                                pathname: `${arc.path.base}hotlist/${row.AGENT_ID}/${row.EMAIL}`,
                                state: { id: row.AGENT_ID, name: row.AGENT_NAME },
                                }}
                            >
                                {row.AGENT_NAME}
                            </Link>
                            </td>
                        );
                        }

                        return (
                        <td key={colIndex} className={col.class || ''}>
                            {cellValue !== undefined ? cellValue : '-'}
                        </td>
                        );
                    })}
                    </tr>
                ))}
                </tbody>
            </table>
        );
    }


    /* renderTable(columns, rows) {
        return (
            <table>
                <thead>
                <tr>
                    {
                        columns.map((column, index) => 
                            <th key={index} className="Pipeline_th">{column.name}</th>
                        )
                    }
                </tr>
                </thead>
                <tbody>
                    {
                        rows.map(value => 
                            <tr key={value.AGENT_ID}>
                                <td className='Pipeline_td'>
                                    <Link to={{pathname: `${arc.path.base}hotlist/${value.AGENT_ID}/${value.EMAIL}`, state: {id: value.AGENT_ID, name: value.AGENT_NAME}}}>{value.AGENT_NAME}</Link>
                                 </td>
                                <td className='Pipeline_column_numeric'>
                                    {value.hsc_properties_count}                                    
                                </td>
                                <td className='Pipeline_column_numeric'>
                                    {value.hsc_agents}                                    
                                </td>
                                <td className='Pipeline_column_numeric'>
                                    {value.hsc_buyers}                                                       
                                </td>
                            </tr>
                        )
                    }
                </tbody>
            </table>
        );
    } */

    render(){
        const {rows, loading, isPrint, printBackground, query,hscAgentsData} = this.state;
        const d = new Date();
        const date = d.getMonth()+1+'/'+d.getDate()+'/'+d.getFullYear();

        return (
            <div className='Pipeline'>
                <div className='print-container' style={{backgroundImage: isPrint && printBackground}}>
                    <div className='Pipeline_head'>
                        <div className="Pipeline_head_left">
                            <h3 className='Pipeline_h3'>Hot List</h3>
                            <h4 className='Pipeline_h4'>{date}</h4>
                        </div>
                        <div className='Pipeline_head_right'>
                            {""}
                        </div>
                    </div>
                    {
                        loading ?
                            <div className='loading'>Loading data...</div>
                            :
                            this.renderTable(columns, hscAgentsData)
                    }
                </div>
                <div className='preload-print-background' style={{backgroundImage: printBackground}}/>
            </div>
        )
    }
   
}
